import { LocationType } from "./types";

export const LOCATION_TYPES: Record<string, LocationType> = {
  COUNTRY: "COUNTRY",
  REGION: "REGION",
  STATE: "STATE",
};

export const LOCATION_MESSAGES = {
  COUNTRY: {
    PLACEHOLDER: "Search countries...",
    NO_RESULTS: "No countries found",
  },
  REGION: {
    PLACEHOLDER: "Search regions...",
    NO_RESULTS: "No regions found",
  },
  STATE: {
    PLACEHOLDER: "Search states...",
    NO_RESULTS: "No states found",
  },
};

export const TOGGLE_BUTTON_OPTIONS = [
  LOCATION_TYPES.REGION,
  LOCATION_TYPES.COUNTRY,
  LOCATION_TYPES.STATE,
];

export const DEFAULT_COUNTRY_FOR_STATE = "US";
